import { render, staticRenderFns } from "./detailEntry.vue?vue&type=template&id=5158241e&scoped=true"
import script from "./detailEntry.vue?vue&type=script&lang=js"
export * from "./detailEntry.vue?vue&type=script&lang=js"
import style0 from "./detailEntry.vue?vue&type=style&index=0&id=5158241e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5158241e",
  null
  
)

export default component.exports